import storelocatorSlice from '@state/features/storelocator.slice';
import api from '@utils/api';
import { all, call, fork, put, select, takeEvery } from 'redux-saga/effects';
import { StoreLocatorActionTypes } from './common.types';
function* handleSearchStores(action) {
    const { city, country } = action.payload;
    let results = yield call(api.searchStores, action.payload);
    if (results.meta) {
        yield put(storelocatorSlice.actions.updateMetadata(results === null || results === void 0 ? void 0 : results.meta));
    }
    let stores = results === null || results === void 0 ? void 0 : results.stores;
    if (results) {
        //filter stores bases on city/country slug on URL
        if (city) {
            stores = results === null || results === void 0 ? void 0 : results.stores.filter((store) => store.slugcity === `${country}/${city}`);
        }
        else if (country) {
            stores = results === null || results === void 0 ? void 0 : results.stores.filter((store) => store.slugcountry === country);
        }
    }
    yield put(storelocatorSlice.actions.updateStores(stores));
}
function* handleFetchStoreDetails(action) {
    const details = yield call(api.searchStoreDetails, action.payload);
    yield put(storelocatorSlice.actions.setCurrentStore(details.ID));
    yield put(storelocatorSlice.actions.updateStores([details]));
}
function* handleUpdateBounds(action) {
    const { stores, updateBounds, storesInMap } = yield select((state) => state.storelocator);
    const newBounds = new google.maps.LatLngBounds({ lat: action.payload.newBounds.south, lng: action.payload.newBounds.west }, { lat: action.payload.newBounds.north, lng: action.payload.newBounds.east });
    if ((!updateBounds || !newBounds.equals(updateBounds)) && !action.payload.fromSearch) {
        const filtered = stores.filter((store) => newBounds.contains(new google.maps.LatLng(store.latitude, store.longitude)));
        if (JSON.stringify(filtered) != JSON.stringify(storesInMap)) {
            yield put(storelocatorSlice.actions.updateStoresInMap(filtered));
        }
    }
    if (action.payload.fromSearch) {
        let storesInBoundaries = stores.filter((store) => newBounds.contains(new google.maps.LatLng(store.latitude, store.longitude)));
        if (!updateBounds || !newBounds.equals(updateBounds) || !storesInBoundaries.every((store) => storesInMap.includes(store))) {
            yield put(storelocatorSlice.actions.setUpdateBounds(action.payload.newBounds));
        }
    }
    // else {
    //   yield put(storelocatorSlice.actions.setBounds(action.payload.newBounds));
    // }
}
function* handleUseLocation(action) {
    yield put(storelocatorSlice.actions.updateLocation(action.payload));
}
/**
 * @desc Watches every specified action and runs effect method and passes action args to it
 */
function* watchFetchRequest() {
    yield takeEvery(StoreLocatorActionTypes.FETCH_STORES, handleSearchStores);
    yield takeEvery(StoreLocatorActionTypes.FETCH_STORE_DETAILS, handleFetchStoreDetails);
    yield takeEvery(StoreLocatorActionTypes.UPDATE_BOUNDS, handleUpdateBounds);
    yield takeEvery(StoreLocatorActionTypes.USE_LOCATION, handleUseLocation);
}
/**
 * @desc saga init, forks in effects, other sagas
 */
export default function* minicartSaga() {
    yield all([fork(watchFetchRequest)]);
}
